<template>
<div>
  <div class="row">
    <div
      class="col-xs-12"
      style="padding-left: 30px;"
    >
      <div
        class="row filter-row"
        v-if="showTimeRange"
      >
        <div class="col-xs-12">
          <div class="date">
            <label class="demonstration">Intevalo</label>
            <el-date-picker
              @change="setRangeDate($event)"
              v-model="rangeDate"
              type="datetimerange"
              format="dd/MM/yyyy"
              start-placeholder="Data início"
              end-placeholder="Data término"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="row filter-row">
        <div class="col-xs-12">
          <input-categories-tags @change="onChangeFilters"></input-categories-tags>
        </div>
      </div>
      <div class="row filter-row">
        <div class="col-xs-12">
          <button
            class="btn btn-info"
            @click="$emit('filter')"
          >{{buttomLabel}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {DatePicker} from 'element-ui'
import TagList from 'src/components/Trg/Tags/ListTags.vue'
import InputCategoriesTags from 'src/components/Trg/Tags/InputCategoriesTags.vue'

export default {
  name: 'dashboard-form-filters',

  props: {
    showTimeRange: {
      default: true,
      type: Boolean
    },
    buttomLabel: {
      default: 'Filtrar',
      type: String
    }
  },

  components: {
    [DatePicker.name]: DatePicker,
    TagList,
    InputCategoriesTags
  },

  data () {
    return {
      tagsSelected: {},
      rangeDate: []
    }
  },

  computed: {
    ...mapGetters('tags', ['tags'])
  },

  methods: {
    ...mapActions({
      setRangeDate: 'changeRange'
    }),
    ...mapActions('tags', {
      setTags: 'setTagsDashboard',
      fetchTags: 'fetchAll'
    }),
    ...mapActions('categories', {
      fetchCategories: 'fetchAll'
    }),
    onChangeFilters (event) {
      if (!this.tagsSelected.hasOwnProperty(event.categorie)) {
        this.tagsSelected[event.categorie] = []
      }
      this.setFilters(event)
      this.setTags({payload: this.tagsSelected, tags: this.tags})
    },

    setFilters (input) {
      if (this.tagsSelected[input.categorie].indexOf(input.tag) !== -1) {
        return (this.tagsSelected[input.categorie].splice(this.tagsSelected[input.categorie].indexOf(input.tag), 1))
      }

      return this.tagsSelected[input.categorie].push(input.tag)
    }
  },

  mounted () {
    this.fetchTags({limit: 999})
    this.fetchCategories({limit: 999})
  }
}
</script>

<style scoped>
  .filter-row {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Trg/Filters/DashboardFormFilters.vue